<template>
    <form method="post" @submit.prevent="submitForm">
        <table class="table table-borderless">
            <tbody>
            <tr
                v-for="(item, index) in poitems"
                :key="index"
                class="bg-gray-light mb-5 border-bottom">
                <td>
                    <!-- <label class="">Purchase Order Item Name: </label> -->
                    <input
                        type="text"
                        name="ItemName"
                        class="form-control is-valid"
                        v-model="item.ItemName"
                        readonly
                    />
                    <span class="badge badge-danger">
                        Remaining Quantity - {{ item.RemainingQuantity }}
                    </span>
                    <span class="badge badge-success">
                        Received Quantity - {{ item.ReceivedQuantity }}
                    </span>
                    <span class="badge badge-info">
                        Ordered Quantity - {{ item.Quantity }}
                    </span>
                    <span class="badge badge-warning text-white">
                        Rejected Quantity - {{ item.RejectedQuantity }}
                    </span>
                    <delivery-challan-item-batch :item-id="item.Id" ref="dcItemBatches"></delivery-challan-item-batch>
                </td>
            </tr>
            <tr>
                <td class="text-right">
                    <!-- <button
                        class="mt-5 btn btn-info"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Add New Item"
                    >
                        Add new item
                    </button> -->
                    <button type="submit"
                            class="mt-5 btn btn-success">Save
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
    </form>
</template>

<script>
    import DeliveryChallanItemBatch from './../delivery-challan-items/DeliveryChallanItemBatch';

    export default {
        name: "delivery-challan-items",
        components: {
            'delivery-challan-item-batch': DeliveryChallanItemBatch
        },
        props: ['deliveryChallanId', 'purchaseOrderId'],
        data() {
            return {
                poitems: null,
                formData: null,
            };
        },
        methods: {
            submitForm() {
                var allBatches = this.$refs.dcItemBatches

                var singleBatch = [];
                this.poitems.forEach(function (item, index) {
                    singleBatch.push(allBatches[index].data)
                });
                this.formData = {
                    DeliveryChallanId : this.deliveryChallanId,
                    PurchaseOrderId : this.purchaseOrderId,
                    data : singleBatch
                }
                this.postDeliveryChallanItems()
            },
            postDeliveryChallanItems() {
                axios.post('delivery-challan/items/store', this.formData)
                    .then(response => {
                        Swal.fire({
                            title: 'Submitted Successfully',
                            icon: 'success',
                        })
                        location.reload();
                    }).catch(error => {
                    this.errored = true
                })
                    .finally(() => this.loading = false)
            },
            getPurchaseOrderItems() {
                axios.get('delivery-challan/items/' + this.deliveryChallanId)
                    .then(response => {
                        this.poitems = response.data.data;
                        // console.log(response.data)
                    }).catch(error => {
                    this.errored = true
                })
                    .finally(() => this.loading = false)
            },
            getPurchaseOrderQuantity(){
                axios.get('purchase-order/items/quantity/' + this.purchaseOrderId)
                    .then(response => {
                        // console.log(response.data)
                    }).catch(error => {
                    this.errored = true
                })
                    .finally(() => this.loading = false)
            },
        },
        mounted() {
            this.getPurchaseOrderItems();
            this.getPurchaseOrderQuantity();
        },
    };
</script>

<style lang="scss" scoped>
</style>
